export default "__VITE_ASSET__38edcd98__"